import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { dramaMeta, watchGuide } from '@/mocks/drama';

export default function Overview() {
  return (
    <section id="overview" className="scroll-mt-32 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="剧集速览"
            title="一部用单元故事讲人性的都市悬疑剧"
            desc="在正式看演员表与人物关系之前，先用一分钟了解这部剧的基本信息与它在讲什么。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <Reveal>
            <div className="space-y-5 text-sm leading-relaxed text-foreground-700 md:text-base">
              <p>{dramaMeta.intro}</p>
              <p>{dramaMeta.intro2}</p>

              <div className="rounded-lg border border-background-200 bg-background-100/70 p-5">
                <div className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
                  <i className="ri-information-line text-primary-500" />
                  观剧前需要知道的一点
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  本剧采用「多个独立单元」的结构，每一段故事都有各自的人物与冲突，因此并不存在一位从头到尾的绝对主角。
                  曼婷与恩诚的故事线贯穿其中多个单元，是串联全剧情感的关键线索。
                </p>
              </div>
            </div>

            <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {watchGuide.map((item) => (
                <div
                  key={item.label}
                  className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-lg text-secondary-700">
                    <i className={item.icon} />
                  </span>
                  <div className="min-w-0">
                    <div className="text-xs text-foreground-500">{item.label}</div>
                    <div className="truncate text-sm font-medium text-foreground-900">{item.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="relative h-[280px] overflow-hidden rounded-lg md:h-full md:min-h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=Stack%20of%20old%20case%20files%20and%20a%20brass%20magnifying%20glass%20under%20warm%20table%20lamp%20light%2C%20deep%20shadows%2C%20dust%20motes%20in%20the%20air%2C%20investigative%20crime%20drama%20still%20life%2C%20cinematic%20tone%2C%20no%20people&width=1600&height=900&seq=desire-overview-files&orientation=landscape"
                alt="剧集氛围：案卷与放大镜组成的悬疑风格静物"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <p className="font-heading text-lg font-semibold text-white md:text-xl">
                  「欲望」不是答案，而是一道选择题
                </p>
                <p className="mt-1 text-xs text-white/75 md:text-sm">
                  金钱、情感、恐惧同时逼近时，你会怎么选？
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}